The input parameter for the `deleteWebhookSubscription` mutation.
